(function($)
{
    'use strict';

    window.PaymentPlanWizard = {

        ajaxUrl:
            '/apps/trainingportal/ajax/',

        currentStep: 1,

        amount: 0,

        instalments: 3,

        storefrontCurrency: 'GBP',
        

        schedule: [],

        customer: {},

        customerId: null,

        applicationId: null,

        stripeCustomerId: null,

        setupIntentId: null,

        clientSecret: null,

        paymentMethodId: null,

        paymentIntentId: null,

        firstPaymentVerified: false,

        paymentPlanId: null,

        signWellDocumentId: null,

        signWellEmbed: null,

        agreementStatusTimer: null,

        productId: null,

        productTitle: null,

        cartItems: [],

        cartDiscountCodes: [],

        shopDomain: '',

        stripe: null,

        elements: null,

        cardElement: null,

        attribution: {},

        reportMetaPurchase: function(planTotal)
        {
            const privacy = window.Shopify && window.Shopify.customerPrivacy;
            const paymentIntentId = String(this.paymentIntentId || '');
            const amount = Number(planTotal);

            if (!privacy || typeof privacy.marketingAllowed !== 'function'
                || !privacy.marketingAllowed()
                || (typeof privacy.saleOfDataAllowed === 'function'
                    && !privacy.saleOfDataAllowed())
                || typeof window.fbq !== 'function'
                || !paymentIntentId
                || !Number.isFinite(amount)
                || amount <= 0)
            {
                return;
            }

            const storageKey = 'payment-plan-meta-purchase-' + paymentIntentId;

            try
            {
                if (window.localStorage.getItem(storageKey))
                {
                    return;
                }

                window.fbq('trackSingle', '1426776537501843', 'Purchase', {
                    value: amount,
                    currency: 'GBP'
                }, {
                    eventID: paymentIntentId
                });

                window.localStorage.setItem(storageKey, '1');
            }
            catch (error)
            {
                console.warn('Unable to report payment plan Meta purchase:', error);
            }
        },

        reportGooglePurchase: function(planTotal)
        {
            const privacy = window.Shopify && window.Shopify.customerPrivacy;
            const paymentIntentId = String(this.paymentIntentId || '');
            const amount = Number(planTotal);

            if (!privacy || typeof privacy.marketingAllowed !== 'function'
                || !privacy.marketingAllowed()
                || (typeof privacy.saleOfDataAllowed === 'function'
                    && !privacy.saleOfDataAllowed())
                || typeof window.gtag !== 'function'
                || !paymentIntentId
                || !Number.isFinite(amount)
                || amount <= 0)
            {
                return;
            }

            const storageKey = 'payment-plan-google-purchase-' + paymentIntentId;

            try
            {
                if (window.localStorage.getItem(storageKey))
                {
                    return;
                }

                window.gtag('event', 'conversion', {
                    send_to: 'AW-11239307642/hjgpCMWamqIdEPryqO8p',
                    value: amount,
                    currency: 'GBP',
                    transaction_id: paymentIntentId
                });

                window.localStorage.setItem(storageKey, '1');
            }
            catch (error)
            {
                console.warn('Unable to report payment plan Google conversion:', error);
            }
        },

        loadAttributionConsent: function()
        {
            if (window.Shopify && typeof window.Shopify.loadFeatures === 'function')
            {
                window.Shopify.loadFeatures([
                    { name: 'consent-tracking-api', version: '0.1' }
                ], function(error)
                {
                    if (!error)
                    {
                        window.PaymentPlanWizard.attribution =
                            window.PaymentPlanWizard.captureAttribution();
                    }
                });
            }
        },

        captureAttribution: function()
        {
            const privacy = window.Shopify && window.Shopify.customerPrivacy;

            if (!privacy || typeof privacy.marketingAllowed !== 'function'
                || !privacy.marketingAllowed()
                || (typeof privacy.saleOfDataAllowed === 'function'
                    && !privacy.saleOfDataAllowed()))
            {
                return {};
            }

            const cookies = {};
            document.cookie.split(';').forEach(function(part)
            {
                const index = part.indexOf('=');
                if (index > 0)
                {
                    cookies[part.slice(0, index).trim()] =
                        decodeURIComponent(part.slice(index + 1).trim());
                }
            });

            const query = new URLSearchParams(window.location.search);
            const stored = function(key)
            {
                try
                {
                    return sessionStorage.getItem(key) || localStorage.getItem(key) || '';
                }
                catch (error)
                {
                    return '';
                }
            };
            const googleCookie = cookies._gcl_aw || '';
            const googleClickId = googleCookie.split('.').slice(2).join('.');
            const value = function(key, fallback)
            {
                return String(query.get(key) || stored(key) || fallback || '')
                    .trim().slice(0, 512);
            };

            return {
                marketing_consent: true,
                captured_at: new Date().toISOString(),
                gclid: value('gclid', googleClickId),
                gbraid: value('gbraid'),
                wbraid: value('wbraid'),
                fbclid: value('fbclid'),
                fbp: String(cookies._fbp || '').slice(0, 512),
                fbc: String(cookies._fbc || '').slice(0, 512)
            };
        },

        launch: function(data)
        {
            data = data || {};

            this.productId =
                data.productId || null;

            this.productTitle =
                data.productTitle || null;

            this.cartItems =
                Array.isArray(data.cartItems) ? data.cartItems : [];

            this.shopDomain =
                typeof data.shop === 'string' ? data.shop : '';

            this.loadAttributionConsent();

            this.amount =
                parseFloat(
                    data.amount || 0
                );

            if (
                this.amount > 0
            )
            {
                $('#ppAmount')
                    .val(
                        this.amount.toFixed(2)
                    )
                    .prop(
                        'readonly',
                        true
                    );
            }
            else
            {
                $('#ppAmount')
                    .val('')
                    .prop(
                        'readonly',
                        false
                    );
            }

            this.resetCalculatorView();

            this.setInstalmentOptionsLoading();

            this.prepareInstalmentOptions();

            this.showStep(1);

            $('#esbsPaymentPlanModal')
                .addClass('active');
        },

        open: function(button)
        {
            this.loadAttributionConsent();

            const price = parseFloat(
                $(button).data('price')
            );

            this.productId =
                $(button).data('product-id') || null;

            this.productTitle =
                $(button).data('product-title') || null;

            if (!isNaN(price))
            {
                this.amount = price;

                $('#ppAmount')
                    .val(
                        price.toFixed(2)
                    )
                    .prop(
                        'readonly',
                        true
                    );
            }
            else
            {
                $('#ppAmount')
                    .val('')
                    .prop(
                        'readonly',
                        false
                    );
            }

            this.resetCalculatorView();

            this.updateInstalmentOptions(
                this.amount
            );

            this.showStep(1);

            $('#esbsPaymentPlanModal')
                .addClass('active');
        },

        close: function()
        {
            if (this.agreementStatusTimer)
            {
                clearInterval(this.agreementStatusTimer);
                this.agreementStatusTimer = null;
            }

            $('#esbsPaymentPlanModal')
                .removeClass('active');
        },

        resetCalculatorView: function()
        {
            this.schedule = [];

            this.applicationId = null;

            this.paymentMethodId = null;

            this.paymentIntentId = null;

            this.firstPaymentVerified = false;

            this.paymentPlanId = null;

            this.signWellDocumentId = null;

            this.signWellEmbed = null;

            if (this.agreementStatusTimer)
            {
                clearInterval(this.agreementStatusTimer);
                this.agreementStatusTimer = null;
            }

            $('#signwell-embed').empty();

            $('#signwell-embed')
                .removeClass('d-none');

            $('.payment-plan-calculator-controls')
                .removeClass('is-hidden');

            $('#paymentBreakdown')
                .html('');
        },

        updateInstalmentOptions: function(amount)
        {
            const eligible = Number(amount) > 500;
            const $sixPayments = $('#ppSixInstalments');
            const $select = $('#ppInstalments');
            const $status = $('#ppInstalmentAvailability');

            $sixPayments
                .prop('hidden', !eligible)
                .prop('disabled', !eligible);

            $select
                .prop('disabled', false)
                .attr('aria-busy', 'false')
                .val(eligible ? '6' : '3');

            $('#btnCalculate').prop('disabled', false);

            $status
                .toggleClass('is-eligible', eligible)
                .text(
                    eligible
                        ? 'Your order qualifies for up to 6 monthly payments.'
                        : 'Your order is eligible for 3 monthly payments.'
                );
        },

        setInstalmentOptionsLoading: function()
        {
            $('#ppSixInstalments')
                .prop('hidden', true)
                .prop('disabled', true);

            $('#ppInstalments')
                .val('3')
                .prop('disabled', true)
                .attr('aria-busy', 'true');

            $('#btnCalculate').prop('disabled', true);

            $('#ppInstalmentAvailability')
                .removeClass('is-eligible')
                .text('Checking available payment options…');
        },

        setInstalmentOptionsFallback: function()
        {
            this.updateInstalmentOptions(0);

            $('#ppInstalmentAvailability').text(
                'We could not verify the extended option, so 3 monthly payments are available.'
            );
        },

        preserveInstalmentSelection: function(amount)
        {
            const selected = $('#ppInstalments').val();
            const eligible = Number(amount) > 500;

            $('#ppSixInstalments')
                .prop('hidden', !eligible)
                .prop('disabled', !eligible);

            $('#ppInstalments')
                .prop('disabled', false)
                .attr('aria-busy', 'false')
                .val(eligible && selected === '6' ? '6' : '3');

            $('#ppInstalmentAvailability')
                .toggleClass('is-eligible', eligible)
                .text(
                    eligible
                        ? 'Your order qualifies for up to 6 monthly payments.'
                        : 'Your order is eligible for 3 monthly payments.'
                );

            if (!eligible && selected === '6')
            {
                $('#ppInstalments').val('3');
            }
        },

        calculationData: function(amount, instalments)
        {
            return {
                amount: amount,
                instalments: instalments,
                cart_lines: JSON.stringify(this.cartItems),
                cart_snapshot: btoa(
                    unescape(
                        encodeURIComponent(
                            JSON.stringify({
                                lines: this.cartItems,
                                discounts: this.cartDiscounts || [],
                                discount_codes: this.cartDiscountCodes || []
                            })
                        )
                    )
                ),
                cart_discounts: JSON.stringify(this.cartDiscounts || []),
                discount_codes: JSON.stringify(this.cartDiscountCodes || []),
                shop: this.shopDomain
            };
        },

        requestCalculation: function(amount, instalments)
        {
            return $.ajax({
                url: this.ajaxUrl + 'paymentplan_calculate',
                type: 'POST',
                dataType: 'json',
                data: this.calculationData(amount, instalments)
            });
        },

        prepareInstalmentOptions: function()
        {
            const self = this;

            $.getJSON('/cart.js')
                .done(function(cart)
                {
                    self.captureCart(cart);

                    if (self.cartItems.length === 0)
                    {
                        self.setInstalmentOptionsFallback();
                        return;
                    }

                    self.requestCalculation(self.amount, 3)
                        .done(function(response)
                        {
                            if (response && response.success && response.data)
                            {
                                self.updateInstalmentOptions(response.data.amount);
                                return;
                            }

                            self.setInstalmentOptionsFallback();
                        })
                        .fail(function()
                        {
                            self.setInstalmentOptionsFallback();
                        });
                })
                .fail(function()
                {
                    self.setInstalmentOptionsFallback();
                });
        },

        showStep: function(step)
        {
            $('.wizard-step')
                .addClass('d-none');

            $('.wizard-step[data-step="' + step + '"]')
                .removeClass('d-none');

            this.currentStep = step;

            const progress =
                (step / 5) * 100;

            $('#wizardProgress')
                .css(
                    'width',
                    progress + '%'
                );

            $('.esbs-step-nav-item')
                .removeClass(
                    'active complete'
                )
                .each(function()
                {
                    const navStep = parseInt(
                        $(this).data('nav-step'),
                        10
                    );

                    if (navStep < step)
                    {
                        $(this).addClass(
                            'complete'
                        );
                    }
                    else if (navStep === step)
                    {
                        $(this).addClass(
                            'active'
                        );
                    }
                });

            if (step === 1)
            {
                $('#btnPrevious')
                    .hide();
            }
            else
            {
                $('#btnPrevious')
                    .show();
            }

            switch (step)
            {
                case 1:

                    $('#btnNext')
                        .text(
                            'Continue'
                        )
                        .toggle(
                            this.schedule.length > 0
                        );

                    break;

                case 2:

                    $('#btnNext')
                        .text(
                            'Continue'
                        )
                        .show();

                    break;

                case 3:

                    $('#btnNext')
                        .text(
                            'Continue'
                        )
                        .show();

                    break;

                case 4:

                    $('#btnNext')
                        .hide();

                    $('#btnPrevious')
                        .hide();

                    break;

                case 5:

                    $('#btnNext')
                        .hide();

                    $('#btnPrevious')
                        .hide();

                    break;
            }
        },

        calculate: function()
        {
            const amount = parseFloat(
                $('#ppAmount').val()
            );

            const instalments = parseInt(
                $('#ppInstalments').val()
            );

            if (
                isNaN(amount)
                || amount <= 0
            )
            {
                alert(
                    'Please enter a valid amount.'
                );

                return;
            }

            const self = this;

            const calculateFromCart = function()
            {
                if (self.cartItems.length === 0)
                {
                    alert(
                        'Your checkout basket could not be prepared. Please refresh and try again.'
                    );

                    return;
                }

                self.requestCalculation(
                    amount,
                    instalments
                )
            .done(function(response)
            {
                console.log(response);

                if (!response.success)
                {
                    alert(
                        response.message ||
                        'Unable to calculate payment plan.'
                    );

                    return;
                }

                self.preserveInstalmentSelection(
                    response.data.amount
                );

                self.renderSchedule(
                    response.data
                );
            })
            .fail(function(xhr)
            {
                console.log(xhr);

                alert(
                    'Unable to contact server.'
                );
            });
            };

            $.getJSON('/cart.js')
                .done(function(cart)
                {
                    const items = Array.isArray(cart && cart.items)
                        ? cart.items
                        : [];

                    self.captureCart(cart);

                    calculateFromCart();
                })
                .fail(function()
                {
                    calculateFromCart();
                });
        },

        captureCart: function(cart)
        {
            const items = Array.isArray(cart && cart.items)
                ? cart.items
                : [];
            const discounts = [];
            const seen = {};

            const rememberDiscount = function(application)
            {
                const title = String(
                    application && application.title || ''
                ).trim();

                if (title !== '' && !seen[title])
                {
                    seen[title] = true;
                    discounts.push({ title: title });
                }
            };

            [
                cart && cart.cart_level_discount_applications,
                cart && cart.discount_applications,
                cart && cart.discounts
            ].forEach(function(cartDiscounts)
            {
                (Array.isArray(cartDiscounts) ? cartDiscounts : [])
                    .forEach(rememberDiscount);
            });

            this.cartItems = items.map(function(item)
            {
                const lineDiscounts = Array.isArray(
                    item.line_level_discount_allocations
                ) ? item.line_level_discount_allocations : [];

                lineDiscounts.forEach(function(allocation)
                {
                    rememberDiscount(
                        allocation && allocation.discount_application
                    );
                });

                (Array.isArray(item.discounts) ? item.discounts : [])
                    .forEach(rememberDiscount);

                return {
                    product_id: item.product_id,
                    variant_id: item.variant_id,
                    quantity: item.quantity,
                    title: item.product_title || item.title || 'Course',
                    final_price: item.final_price
                };
            });

            this.cartDiscounts = discounts;

            this.storefrontCurrency = String(
                (cart && cart.currency) || 'GBP'
            ).toUpperCase();

            this.cartDiscountCodes = (Array.isArray(cart && cart.discount_codes)
                ? cart.discount_codes
                : [])
                .filter(function(discount)
                {
                    return discount && discount.applicable !== false && discount.code;
                })
                .map(function(discount)
                {
                    return String(discount.code).trim();
                })
                .filter(function(code)
                {
                    return code !== '';
                });
        },

        renderSchedule: function(data)
        {
            this.amount =
                data.amount;

            this.instalments =
                data.instalments;

            this.schedule =
                data.schedule;

            let html = '';

            html +=
                '<div class="payment-plan-summary is-expanded">';

            html +=
                '<h4>Your Payment Plan</h4>';

            const storefrontCurrency = String(
                this.storefrontCurrency || 'GBP'
            )
                .toUpperCase()
                .replace(/[^A-Z]/g, '')
                .substring(0, 3);

            if (storefrontCurrency !== 'GBP')
            {
                html +=
                    '<div class="payment-plan-currency-notice" role="note" '
                    + 'style="margin:18px 0;padding:18px 20px;border:1px solid #d8c47a;'
                    + 'border-radius:10px;background:#fff9e6;color:#171714;line-height:1.5;">'
                    + '<strong style="display:block;margin-bottom:5px;">Payments are processed in GBP</strong>'
                    + 'Your cart has been converted from '
                    + storefrontCurrency
                    + ' to GBP. Your payment plan total is <strong>£'
                    + Number(data.amount).toFixed(2)
                    + '</strong>. Your bank may apply its own exchange rate or currency conversion fee.'
                    + '</div>';
            }

            html +=
                '<div class="payment-plan-first-payment">';

            html +=
                'First payment today: <strong>£'
                + Number(
                    data.first_payment_today
                ).toFixed(2)
                + '</strong>';

            html +=
                '</div>';

            html +=
                '<table class="payment-plan-table">';

            html +=
                '<thead>';

            html +=
                '<tr>';

            html +=
                '<th>#</th>';

            html +=
                '<th>Date</th>';

            html +=
                '<th>Amount</th>';

            html +=
                '</tr>';

            html +=
                '</thead>';

            html +=
                '<tbody>';

            data.schedule.forEach(
                function(row)
                {
                    html += '<tr>';

                    html +=
                        '<td data-label="#">'
                        + row.payment_number
                        + '</td>';

                    html +=
                        '<td data-label="Date">'
                        + new Date(
                            row.due_date
                        ).toLocaleDateString(
                            'en-GB'
                        )
                        + '</td>';

                    html +=
                        '<td data-label="Amount">£'
                        + Number(
                            row.amount
                        ).toFixed(2)
                        + '</td>';

                    html +=
                        '</tr>';
                }
            );

            html +=
                '</tbody>';

            html +=
                '</table>';

            html +=
                '</div>';

            $('#paymentBreakdown')
                .html(html);

            $('.payment-plan-calculator-controls')
                .addClass('is-hidden');

            $('#btnNext')
                .prop(
                    'disabled',
                    false
                )
                .show();
        },

        previous: function()
        {
            if (
                this.currentStep <= 1
            )
            {
                return;
            }

            this.showStep(
                this.currentStep - 1
            );
        },

        saveCustomer: function()
        {
            this.customer = {

                firstname:
                    $('#firstname').val().trim(),

                lastname:
                    $('#lastname').val().trim(),

                email:
                    $('#email').val().trim(),

                telephone:
                    $('#telephone').val().trim(),

                address1:
                    $('#address1').val().trim(),

                address2:
                    $('#address2').val().trim(),

                city:
                    $('#city').val().trim(),

                county:
                    $('#county').val().trim(),

                postcode:
                    $('#postcode').val().trim(),

                country:
                    $('#country').val().trim()
            };

            return this.customer;
        },

        validateCustomer: function()
        {
            this.saveCustomer();

            if (
                this.customer.firstname === ''
            ) {
                return 'Please enter your first name.';
            }

            if (
                this.customer.lastname === ''
            ) {
                return 'Please enter your last name.';
            }

            if (
                this.customer.email === ''
            ) {
                return 'Please enter your email address.';
            }

            if (
                this.customer.address1 === ''
            ) {
                return 'Please enter your address.';
            }

            if (
                this.customer.postcode === ''
            ) {
                return 'Please enter your postcode.';
            }

            return true;
        },

        startApplication: function()
        {
            const self = this;

            const submitApplication = function()
            {
                $.ajax({

                    url:
                        self.ajaxUrl +
                        'paymentplan_start',

                    type: 'POST',

                    dataType: 'json',

                    data:
                        $.extend(
                            {},
                            self.customer,
                            {
                                amount: self.amount,
                                instalments: self.instalments,
                                cart_lines: JSON.stringify(self.cartItems),
                                cart_snapshot: btoa(
                                    unescape(
                                        encodeURIComponent(
                                            JSON.stringify({
                                                lines: self.cartItems,
                                                discounts: self.cartDiscounts || [],
                                                discount_codes: self.cartDiscountCodes || []
                                            })
                                        )
                                    )
                                ),
                                cart_discounts: JSON.stringify(
                                    self.cartDiscounts || []
                                ),
                                discount_codes: JSON.stringify(
                                    self.cartDiscountCodes || []
                                ),
                                attribution: JSON.stringify(
                                    self.captureAttribution()
                                ),
                                shop: self.shopDomain
                            }
                        )

                })
                .done(function(response)
                {
                console.log(response);

                if (!response.success)
                {
                    alert(
                        response.message ||
                        'Unable to start application.'
                    );

                    return;
                }

                const data =
                    response.data || response;

                self.customerId =
                    data.customer_id;

                self.applicationId =
                    data.application_id;

                self.stripeCustomerId =
                    data.stripe_customer_id;

                self.setupIntentId =
                    data.setup_intent_id;

                self.clientSecret =
                    data.client_secret;

                self.initialiseStripe();

                self.showStep(3);
                })
                .fail(function()
                {
                alert(
                    'Unable to contact server.'
                );
                });
            };

            $.getJSON('/cart.js')
                .done(function(cart)
                {
                    self.captureCart(cart);

                    submitApplication();
                })
                .fail(function()
                {
                    submitApplication();
                });
        },

        next: async function()
        {
            switch (
                this.currentStep
            )
            {
                case 1:

                    if (
                        this.schedule.length === 0
                    )
                    {
                        alert(
                            'Please calculate your payment plan first.'
                        );

                        return;
                    }

                    this.showStep(2);

                    return;

                case 2:

                    const valid =
                        this.validateCustomer();

                    if (
                        valid !== true
                    )
                    {
                        alert(valid);

                        return;
                    }

                    this.startApplication();

                    return;

                case 3:

                    if (!this.paymentIntentId && !this.paymentMethodId)
                    {
                        const saved =
                            await this.confirmCardSetup();

                        if (!saved)
                        {
                            return;
                        }
                    }

                    let paid = true;

                    if (!this.firstPaymentVerified)
                    {
                        paid = await this.takeFirstPayment();
                    }

                    if (!paid)
                    {
                        return;
                    }

                    const confirmedPayment =
                        await this.confirmFirstPayment();

                    if (!confirmedPayment)
                    {
                        return;
                    }

                    this.firstPaymentVerified = true;

                    this.reportMetaPurchase(confirmedPayment.plan_total_gbp);
                    this.reportGooglePurchase(confirmedPayment.plan_total_gbp);

                    const agreement =
                        await this.beginAgreement();

                    if (!agreement)
                    {
                        return;
                    }

                    this.showStep(4);

                    this.openAgreement();

                    return;

                case 4:
                    return;
            }
        },

        initialiseStripe: function()
        {
            if (this.cardElement)
            {
                return;
            }

            if (typeof Stripe === 'undefined')
            {
                console.error(
                    'Stripe JS not loaded.'
                );

                alert(
                    'Payment system unavailable.'
                );

                return;
            }

            this.stripe = Stripe(
                'pk_live_4M4ThI7v5mRSi2x0QRrpklf0'
            );

            this.elements =
                this.stripe.elements();

            this.cardElement =
                this.elements.create(
                    'card'
                );

            this.cardElement.mount(
                '#stripe-card-element'
            );
        },

        confirmCardSetup: async function()
        {
            const self = this;

            try
            {
                const result =
                    await self.stripe.confirmCardSetup(

                        self.clientSecret,

                        {
                            payment_method: {

                                card:
                                    self.cardElement,

                                billing_details: {

                                    name:
                                        self.customer.firstname
                                        + ' '
                                        + self.customer.lastname,

                                    email:
                                        self.customer.email,

                                    phone:
                                        self.customer.telephone
                                }
                            }
                        }
                    );

                if (result.error)
                {
                    alert(
                        result.error.message
                    );

                    return false;
                }

                self.paymentMethodId =
                    result.setupIntent
                        .payment_method;

                return true;
            }
            catch (e)
            {
                console.error(e);

                alert(
                    'Unable to save card.'
                );

                return false;
            }
        },

        takeFirstPayment: async function()
        {
            const self = this;

            try
            {
                const response =
                    await $.ajax({

                        url:
                            self.ajaxUrl +
                            'paymentplan_takepayment',

                        type: 'POST',

                        dataType: 'json',

                        data: {

                            amount:
                                self.amount,

                            instalments:
                                self.instalments,

                            application_id:
                                self.applicationId,

                            stripe_customer_id:
                                self.stripeCustomerId,

                            stripe_payment_method_id:
                                self.paymentMethodId
                        }
                    });

                console.log(
                    'paymentplan_takepayment',
                    response
                );

                if (!response.success)
                {
                    alert(
                        response.message ||
                        'Unable to take payment.'
                    );

                    return false;
                }

                const data =
                    response.data || response;

                self.paymentIntentId =
                    data.payment_intent_id;

                if (data.already_paid)
                {
                    return true;
                }

                if (data.status === 'processing' || data.status === 'requires_capture')
                {
                    alert('Your payment is still being processed. Please try again shortly; do not submit another payment.');
                    return false;
                }

                const clientSecret =
                    data.client_secret;

                if (!clientSecret)
                {
                    alert(
                        'No payment client secret returned.'
                    );

                    return false;
                }

                const result =
                    await self.stripe.confirmCardPayment(
                        clientSecret
                    );

                console.log(
                    'confirmCardPayment',
                    result
                );

                if (result.error)
                {
                    alert(
                        result.error.message
                    );

                    return false;
                }

                if (
                    !result.paymentIntent
                )
                {
                    alert(
                        'Payment confirmation failed.'
                    );

                    return false;
                }

                if (
                    result.paymentIntent.status
                    !== 'succeeded'
                )
                {
                    alert(
                        'Payment status: ' +
                        result.paymentIntent.status
                    );

                    return false;
                }

                self.paymentIntentId =
                    result.paymentIntent.id;

                return true;
            }
            catch (e)
            {
                console.error(e);

                if (
                    e.responseJSON
                )
                {
                    console.log(
                        e.responseJSON
                    );
                }

                alert(
                    'Unable to process payment.'
                );

                return false;
            }
        },

        confirmFirstPayment: async function()
        {
            try
            {
                const response = await $.ajax({
                    url: this.ajaxUrl + 'paymentplan_confirmpayment',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        application_id: this.applicationId,
                        payment_intent_id: this.paymentIntentId
                    }
                });

                if (!response.success)
                {
                    alert(response.message || 'Unable to verify your first payment. Please try again.');
                    return false;
                }

                return response.data || response;
            }
            catch (error)
            {
                console.error('Payment plan first payment verification failed:', error);
                alert('Your payment may have succeeded, but we could not verify it yet. Please try again.');
                return false;
            }
        },

        beginAgreement: async function()
        {
            const self = this;

            try
            {
                const response = await $.ajax({
                    url: self.ajaxUrl + 'paymentplan_generateagreement',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        application_id: self.applicationId,
                        payment_intent_id: self.paymentIntentId
                    }
                });

                if (!response.success)
                {
                    const message = response.message ||
                        'Unable to prepare your agreement.';

                    console.error(
                        'SignWell agreement creation failed:',
                        response
                    );

                    alert(message);

                    return false;
                }

                const data = response.data || response;

                self.signWellDocumentId = data.document_id;
                self.signWellEmbeddedUrl = data.embedded_signing_url;

                return Boolean(self.signWellDocumentId && self.signWellEmbeddedUrl);
            }
            catch (e)
            {
                const response = e.responseJSON || {};

                const message = response.message ||
                    e.message ||
                    'Unable to prepare your agreement.';

                console.error(
                    'SignWell agreement creation failed:',
                    e,
                    response
                );

                alert(message);
                return false;
            }
        },

        openAgreement: function()
        {
            const self = this;

            $('#signwellAgreementStatus').text(
                'Please read and sign your agreement below, then select Continue.'
            );

            $('#signwell-embed').empty();

            if (typeof SignWellEmbed === 'undefined')
            {
                $('#signwellAgreementStatus').text(
                    'The agreement service could not be loaded. Please refresh and try again.'
                );

                return;
            }

            self.signWellEmbed = new SignWellEmbed({
                url: self.signWellEmbeddedUrl,
                containerId: 'signwell-embed',
                showHeader: true,
                allowClose: false,
                allowDecline: true,
                events: {
                    completed: function()
                    {
                        $('#signwell-embed')
                            .addClass('d-none')
                            .empty();

                        $('#signwellAgreementStatus').text(
                            'Your agreement has been signed. Activating your payment plan...'
                        );

                        self.completeAgreement();
                    },
                    declined: function()
                    {
                        $('#signwellAgreementStatus').text(
                            'The agreement was declined. Your payment plan has not been created.'
                        );
                    },
                    error: function()
                    {
                        $('#signwellAgreementStatus').text(
                            'There was a problem loading the agreement. Please refresh and try again.'
                        );
                    }
                }
            });

            self.signWellEmbed.open();
        },

        watchAgreementCompletion: function()
        {
            const self = this;

            if (self.agreementStatusTimer)
            {
                clearInterval(self.agreementStatusTimer);
            }

            self.agreementStatusTimer = setInterval(
                function()
                {
                    $.ajax({
                        url: self.ajaxUrl + 'paymentplan_agreementstatus',
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            provider_document_id: self.signWellDocumentId
                        }
                    })
                    .done(function(response)
                    {
                        const data = response.data || response;

                        if (response.success && data.completed)
                        {
                            clearInterval(self.agreementStatusTimer);
                            self.agreementStatusTimer = null;
                            self.completeAgreement();
                        }
                    });
                },
                3000
            );
        },

        completeAgreement: async function()
        {
            const self = this;

            if (self.agreementStatusTimer)
            {
                clearInterval(self.agreementStatusTimer);
                self.agreementStatusTimer = null;
            }

            $('#signwellAgreementStatus').text(
                'Finalising your payment plan...'
            );

            try
            {
                const response = await $.ajax({
                    url: self.ajaxUrl + 'paymentplan_complete',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        provider_document_id: self.signWellDocumentId
                    }
                });

                if (!response.success)
                {
                    throw new Error(
                        response.message || 'Unable to create payment plan.'
                    );
                }

                const data = response.data || response;

                self.paymentPlanId = data.payment_plan_id;

                $('#paymentPlanOrderConfirmation').addClass('d-none');
                $('#paymentPlanOrderReference').text('');

                if (data.shopify_order_id && !data.shopify_order_error)
                {
                    try
                    {
                        await $.ajax({
                            url: '/cart/clear.js',
                            type: 'POST',
                            dataType: 'json'
                        });
                    }
                    catch (cartError)
                    {
                        console.warn(
                            'The payment plan was completed, but the Shopify cart could not be cleared.',
                            cartError
                        );
                    }

                    $('#paymentPlanSuccessTitle').text(
                        'Payment plan and order confirmed'
                    );

                    $('#paymentPlanSuccessMessage').text(
                        'Your agreement is signed, your first payment has been received, and your course order has been created.'
                    );

                    $('#paymentPlanOrderReference').text(
                        data.shopify_order_name || 'Order created'
                    );

                    $('#paymentPlanOrderConfirmation').removeClass('d-none');
                }
                else
                {
                    $('#paymentPlanSuccessTitle').text(
                        'Payment plan confirmed'
                    );

                    $('#paymentPlanSuccessMessage').text(
                        'Your agreement is signed and your payment plan is active. We are preparing your course order and will contact you if anything else is needed.'
                    );
                }

                var signupEmail = String(
                    (self.customer && self.customer.email) ||
                    $('#email').val() ||
                    ''
                ).trim();
                var loginUrl = '/customer_authentication/login?return_to=%2Fapps%2Fmy%2Fcourses%2Flist&login_hint=' +
                    encodeURIComponent(signupEmail);
                var $successActions = $('<div>', {
                    id: 'paymentPlanSuccessActions',
                    class: 'payment-plan-success-actions'
                });
                var $loginButton = $('<a>', {
                    class: 'payment-plan-login-button',
                    href: loginUrl,
                    text: 'Log in to your courses'
                });

                $('#paymentPlanSuccessActions').remove();
                $successActions.append($loginButton);
                $('#paymentPlanOrderConfirmation').after($successActions);

                self.showStep(5);
            }
            catch (e)
            {
                console.error(e);
                $('#signwellAgreementStatus').text(
                    e.message || 'We could not finalise the payment plan. Please contact us.'
                );
            }
        }
    }
})(jQuery);

$(document).on('click', '#copyPaymentPlanDiscount', function()
{
    const code = $('#paymentPlanDiscountCode').text().trim();

    if (!code)
    {
        return;
    }

    const copied = function()
    {
        $('#paymentPlanDiscountCopied').text('Code copied to your clipboard.');
    };

    if (navigator.clipboard && window.isSecureContext)
    {
        navigator.clipboard.writeText(code).then(copied);
        return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = code;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    copied();
});


$(document).on(
    'click',
    '#closePaymentPlan',
    function()
    {
        PaymentPlanWizard.close();
    }
);

$(document).on(
    'click',
    '.esbs-modal-backdrop',
    function()
    {
        PaymentPlanWizard.close();
    }
);

$(document).on(
    'keydown',
    function(e)
    {
        if (
            e.key === 'Escape'
        )
        {
            PaymentPlanWizard.close();
        }
    }
);

$(document).on(
    'click',
    '#btnCalculate',
    function()
    {
        PaymentPlanWizard.calculate();
    }
);

function setPaymentPlanLoading(isLoading)
{
    const $modal = $('#esbsPaymentPlanModal');

    if (!$modal.hasClass('active'))
    {
        return;
    }

    const $buttons = $modal.find('button');

    if (isLoading)
    {
        $buttons.each(function()
        {
            const $button = $(this);

            $button.data(
                'payment-plan-was-disabled',
                $button.prop('disabled')
            );

            $button.prop('disabled', true);
        });

        $('#paymentPlanLoading').addClass('is-active');

        return;
    }

    $buttons.each(function()
    {
        const $button = $(this);

        $button.prop(
            'disabled',
            Boolean(
                $button.data('payment-plan-was-disabled')
            )
        );

        $button.removeData('payment-plan-was-disabled');
    });

    $('#paymentPlanLoading').removeClass('is-active');
}

$(document).on(
    'ajaxStart.paymentPlanWizard',
    function()
    {
        setPaymentPlanLoading(true);
    }
);

$(document).on(
    'ajaxStop.paymentPlanWizard',
    function()
    {
        setPaymentPlanLoading(false);
    }
);

$(document)
    .off('click.paymentPlanWizard', '#btnNext')
    .on(
        'click.paymentPlanWizard',
        '#btnNext',
        function()
        {
            PaymentPlanWizard.next();
        }
    )
    .off('click.paymentPlanWizard', '#btnPrevious')
    .on(
        'click.paymentPlanWizard',
        '#btnPrevious',
        function()
        {
            PaymentPlanWizard.previous();
        }
    );


$(function()
{
    PaymentPlanWizard.showStep(
        1
    );
});
